package org.catharsis.spendtel.core.navigation

import kotlinx.browser.window

actual fun consumeInitialPublicShareRoute(): PublicShareRoute? {
    val path = window.location.pathname.removePrefix("/").removeSuffix("/")
    if (!path.startsWith("share/")) return null

    val shareId = path.removePrefix("share/").substringBefore("/")
    if (shareId.isBlank()) return null

    return PublicShareRoute(shareId = shareId)
}
